import React from 'react';
import { Wrapper } from 'components/atoms';

const ContainerForm: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default ContainerForm;
